<template>
  <div>
    <el-dialog
      v-el-drag-dialog
      :visible.sync="innerVisible"
      :title="$t('SeaExport.QueryLCLJobOrder')"
      width="1085px"
      append-to-body
      :close-on-click-modal="false"
      :before-close="beforeCloseHandler"
      class="app-main-inner search"
    >
      <div class="app-main-inner-row">
        <search-item
          :config-module="isFba?'130':'131'"
          :reset="true"
          :show-simple="false"
          :expand-adv="true"
          :col-settings="{span:8}"
          :custom-search-items="customSearchItems"
          grid-config-module="131001"
          @advSearchItemCallBack="toQuery"
          @perConfigChange="value=>{perConfigName=value}"
          @refreshGrid="()=>{gridRefreshId+=1}"
          @itemConditionChange="onItemConditionChange"
        >
          <template slot="customType1" slot-scope="{ item, getValueFromChild }">
            <cargo-advance-select
              v-if="item.defaultConditionVal === 'IN' || item.defaultConditionVal === 'NOT IN'"
              key="user-multiple"
              :select-type="selectTypeNames.basic_data_User"
              :url="item.lock || joinSameGroupSlave ? '' : URL.sys.getUsersByPrivilegeDetail"
              :cache="item.lock"
              :method-params="{ 'category': 'role', 'shape': 'op', officeId: $store.getters.currentOfficeId }"
              :clear-not-match="!item.lock"
              filterable
              :disabled="item.lock"
              :callback-params="{ refCode: item.itemName }"
              :default-multiple-value="item.itemValue"
              :multiple="true"
              callback-method-type="obj"
              options-width="300px"
              :headers="[]"
              :fields="[]"
              placeholder=" "
              :static-options="joinSameGroupSlave ? departmentUsers : null"
              @parentCallBack="data=>getValueFromChild(data)"
            />
            <cargo-advance-select
              v-else
              key="user-single"
              :select-type="selectTypeNames.basic_data_User"
              :url="item.lock || joinSameGroupSlave ? '' : URL.sys.getUsersByPrivilegeDetail"
              :cache="item.lock"
              :method-params="{ 'category': 'role', 'shape': 'op', officeId: $store.getters.currentOfficeId }"
              :clear-not-match="!item.lock"
              filterable
              :disabled="item.lock"
              :callback-params="{ refCode: item.itemName }"
              :default-value="item.itemValue"
              callback-method-type="obj"
              options-width="300px"
              :headers="[]"
              :fields="[]"
              placeholder=" "
              :static-options="joinSameGroupSlave ? departmentUsers : null"
              @parentCallBack="data=>getValueFromChild(data)"
            />
          </template>
        </search-item>
      </div>
      <div class="app-main-inner-row">
        <cargo-ag-grid
          :grid-options="gridOptions"
          :column-defs="columnDefs"
          :row-data="rowData"
          style="min-height:300px"
          :per-config-name="perConfigName"
          :refresh-id="gridRefreshId"
          config-module="131001"
          @gridReady="params=>{this.gridApi=params.api}"
        />
      </div>
      <div slot="footer" style="display: flex; justify-content: space-between;">
        <span>
          <b>{{ $t('SeaExport.QuantityOfSelectedOrder') }}：{{ selectedRows.length }}</b>
        </span>
        <div>
          <el-button no="add" type="primary" @click="add">{{ $t('SeaExport.Add3') }}</el-button>
          <el-button no="cancel" @click="beforeCloseHandler">{{ $t('CargoMsg.Cargo_Cancel') }}</el-button>
        </div>
      </div>
    </el-dialog>
  </div>
</template>

<script>

import cargoAdvanceSelect from '@/components/Cargo/Common/cargoAdvanceSelect'
import { TYPE_NAMES } from '@/utils/class/AdvanceSelect'
import { cacheName, cache } from '@/utils/cacheManager'
import ColumnUtils from '@/utils/ColumnUtils'
import { getSeaExportJobsByLclMasterJob } from '@/api/seaExport/seaExportJob'
import cargoCompanySelect from '@/components/Cargo/Common/cargoCompanySelect'
import { Job } from '@/class/model/booking/Job'
import { WarehouseInfo } from '@/class/model/booking/WarehouseInfo'
import searchItem from '@/components/Cargo/Common/cargoCombinationSearch'
import AdvancedSearchField from '@/class/cargo/model/parameters/AdvancedSearchField'
import { getCacheListByKey, getObjectByCache } from '@/utils/basicDataCache'
import { basicCacheKeys } from '@/utils/cacheConfig'
import AdvancedSearchOption from '@/class/cargo/model/parameters/AdvancedSearchOption'
import AdvancedSearchConsts from '@/class/cargo/model/parameters/OperatorConstants'
import * as ContainerLoadType from '@/class/cargo/model/parameters/ContainerLoadType'
import CustomLableUtils from '@/utils/CustomLabelUtils'
import { User } from '@/class/model/sys/User'
import URL from '@/api/urlTranslator'
import * as SystemConstants from '@/class/cargo/model/parameters/SystemConstants'
import { getLoading } from '@/utils/utilBaseElement'

export default {
  name: 'QuerySELclDialog',
  components: { cargoAdvanceSelect, cargoCompanySelect, searchItem },
  props: {
    visible: { type: Boolean, required: true },
    job: { type: Object, required: true }
  },
  data() {
    return {
      innerVisible: false,
      selectTypeNames: TYPE_NAMES,
      URL,
      dischargingPortLock: false,
      perConfigName: '',
      gridRefreshId: 0,
      gridOptions: {
        rowSelection: 'multiple',
        suppressCellSelection: true,
        onRowDataChanged: event => {
          this.onRowDataChanged(event)
        },
        onSelectionChanged: event => {
          // 触发多选
          this.onMultipleSelected(event)
        },
        context: {
          componentParent: this
        }
      },
      rowData: [],
      selectedRows: [],
      gridApi: null,
      customSearchItems: [],
      joinSameGroupSlave: false,
      joinPersonSlave: false,
      departmentUsers: []
    }
  },
  computed: {
    isFba() { // 是否是FBA业务
      return this.job.fba
    },
    columnDefs() {
      return [
        {
          headerName: '',
          field: '',
          width: 40,
          headerCheckboxSelection: true,
          checkboxSelection: true,
          sortable: false,
          suppressSizeToFit: true,
          resizable: false
        }, {
          headerName: this.$t('CargoMsg.Cargo_BusinessNo'),
          field: 'jobNo',
          width: 130
        }, {
          headerName: this.$t('CargoMsg.Cargo_WarehouseNo'),
          field: 'warehouseNo',
          width: 120
        }, {
          headerName: 'MBL',
          field: 'mbl',
          width: 90
        }, {
          headerName: this.$t('CargoMsg.Cargo_AuthorizedClient'),
          field: 'customerId',
          width: 220,
          cellRenderer: params => {
            return ColumnUtils.resolveColumnLabel(TYPE_NAMES.basic_data_Company, 'cmpIdx', params.value, 'chineseName')
          }
        }, {
          headerName: this.$t('CargoMsg.Cargo_BookingAgent'),
          field: 'bookingAgent',
          width: 180,
          cellRenderer: params => {
            return ColumnUtils.resolveColumnLabel(TYPE_NAMES.basic_data_Company, 'cmpIdx', params.value, 'chineseName')
          }
        }, {
          headerName: this.$t('CargoMsg.Cargo_PortOfDischarge'),
          field: 'dischargingPortCode',
          width: 130,
          cellRenderer: params => {
            return ColumnUtils.resolveColumnLabel(TYPE_NAMES.basic_data_Seaport, 'code', params.value, 'englishName')
          }
        }, {
          headerName: 'ETD',
          field: 'etd',
          width: 90,
          cellRenderer: params => {
            return ColumnUtils.formateDateToString(params.value, 'yyyy-MM-dd')
          }
        }, {
          headerName: this.$t('CargoMsg.Cargo_ChineseCargoName'),
          field: 'cargoChineseName',
          width: 120
        }, {
          headerName: this.$t('CargoMsg.Cargo_ItemsNBR'),
          field: 'quantityActual',
          width: 70,
          cellRenderer: params => {
            return ColumnUtils.numberColumnLabelFunc(params.value)
          }
        }, {
          headerName: this.$t('SeaExport.Weight'),
          field: 'weightActual',
          width: 70,
          cellRenderer: params => {
            return ColumnUtils.number1ColumnLabelFunc(params.value)
          }
        }, {
          headerName: this.$t('CargoMsg.Cargo_Cubage'),
          field: 'cubageActual',
          width: 70,
          cellRenderer: params => {
            return ColumnUtils.number3ColumnLabelFunc(params.value)
          }
        }, {
          headerName: 'FBA',
          colId: 'fba',
          field: 'fba',
          initialHide: !this.isFba,
          suppressColumnsToolPanel: !this.isFba,
          width: 70,
          valueFormatter: (params) => {
            return ColumnUtils.booleanLabelFunction(params.value)
          }
        }, {
          headerName: this.$t('FbaJob.AmazonWarehouseCode'),
          colId: 'fbaWarehouseCode',
          field: 'fbaWarehouseCode',
          initialHide: !this.isFba,
          suppressColumnsToolPanel: !this.isFba,
          width: 120
        }, {
          headerName: this.$t('queryJob.DomesticWarehouse'),
          colId: 'fbaWarehouseCmp',
          field: 'fbaWarehouseCmp',
          initialHide: !this.isFba,
          suppressColumnsToolPanel: !this.isFba,
          width: 120,
          valueFormatter: (params) => {
            return params.value ? CustomLableUtils.getLabel(TYPE_NAMES.basic_data_Company, 'cmpIdx', params.value, 'auto_10') : ''
          }
        }, {
          headerName: this.$t('queryJob.ForeignWarehouse'),
          colId: 'overseaWarehouseCode',
          field: 'overseaWarehouseCode',
          initialHide: !this.isFba,
          suppressColumnsToolPanel: !this.isFba,
          width: 120,
          valueFormatter: (params) => {
            return ColumnUtils.resolveColumnLabel(TYPE_NAMES.basic_data_OverseaWarehouse, 'warehouseCode', params.value, 'chineseName')
          }
        }, {
          headerName: this.$t('queryJob.ExpectedTimeAtAmazonWarehouse'),
          colId: 'fbaPreAmazonWhTime',
          field: 'fbaPreAmazonWhTime',
          initialHide: !this.isFba,
          suppressColumnsToolPanel: !this.isFba,
          width: 120,
          valueFormatter: (params) => {
            return ColumnUtils.dateLabelFunc(params.value)
          }
        }, {
          headerName: this.$t('queryJob.ReferenceBoxNumber'),
          colId: 'fbaRefContainerNo',
          field: 'fbaRefContainerNo',
          initialHide: !this.isFba,
          suppressColumnsToolPanel: !this.isFba,
          width: 120
        }, {
          headerName: this.$t('CargoMsg.Cargo_ItemNo'),
          field: 'poNo',
          width: 120
        }, {
          headerName: this.$t('queryJob.destinationAgent'),
          field: 'destinationAgent',
          colId: 'destinationAgent',
          cellRenderer: (params) => {
            return params.value ? CustomLableUtils.getLabel(TYPE_NAMES.basic_data_Company, 'cmpIdx', params.value, 'auto_2') : ''
          },
          hide: true,
          width: 120
        }, {
          headerName: this.$t('SeaExport.NominatedAgent'),
          field: 'designationAgent',
          colId: 'designationAgent',
          cellRenderer: (params) => {
            return params.value ? CustomLableUtils.getLabel(TYPE_NAMES.basic_data_Company, 'cmpIdx', params.value, 'auto_3') : ''
          },
          hide: true,
          width: 120
        },
        { headerName: this.$t('SeaExport.Operation'), field: 'op', width: 120, colId: 'op', hide: true,
          cellRenderer: (params) => {
            return params.value ? CustomLableUtils.getLabel(TYPE_NAMES.basic_data_User, 'userId', params.value, 'auto_op') : ''
          }
        },
        {
          headerName: this.$t('SeaExport.BusinessReferenceNo'),
          field: 'customerRefNo',
          width: 120,
          hide: true
        },
        {
          headerName: this.$t('SeaExport.Hbl2'),
          field: 'hblNbr2',
          colId: 'hblNbr2',
          width: 120,
          hide: true
        }
      ]
    }
  },
  watch: {
    visible(newVal) {
      this.innerVisible = newVal
      if (newVal) {
        this.initData()
      }
    },
    innerVisible(newVal) {
      if (!newVal) {
        this.rowData = []
        this.selectedRows = []
      }
      this.$emit('update:visible', newVal)
    }
  },
  created() {
    if (!this.$store.getters.isAdmin) {
      if (this.$checkPermission(['button_SEBooking_joinSameGroupSlave'])) {
        this.joinSameGroupSlave = true
        User.getAllUsersByDepartments().then(data => {
          this.departmentUsers = data
        })
      } else if (this.$checkPermission(['button_SEBooking_joinPersonSlave'])) {
        this.joinPersonSlave = true
      }
    }
  },
  methods: {
    async initData() {
      await cache.load(cacheName.CONFIG)
      this.dischargingPortLock = Number(cache.config.get('AddLclDischargingPortLock')) !== 0
      //
      if (this.dischargingPortLock && this.job.dischargingPortCode) {
        const port = getObjectByCache(basicCacheKeys.basic_data_Seaport, 'code', this.job.dischargingPortCode)
        if (port) {
          const searchField = new AdvancedSearchField()
          const options = [{ code: port.code, chineseName: port.chineseName, englishName: port.englishName }]
          searchField.itemType = 'select'
          searchField.multiple = 0
          searchField.defaultValue = this.job.dischargingPortCode
          searchField.itemLabel = 'SeaExport.PortOfDischarge'
          searchField.itemName = 'job.DISCHARGING_PORT_CODE'
          searchField.fieldType = 'FIELD_SEAPORT'
          searchField.lock = true
          searchField.dataProvider = options
          searchField.defaultSelected = 1
          searchField.selected = 1
          searchField.action = 2
          this.customSearchItems.push(searchField.formatObj2Json())
        }
      }

      // 头程主票加入小票高级查询
      // FBA
      let searchField = new AdvancedSearchField()
      searchField.multiple = 0
      searchField.defaultValue = true
      searchField.itemLabel = 'FBA'
      searchField.itemName = 'job.FBA'
      searchField.itemValue = ''
      searchField.fieldType = 'FIELD_CHECKBOX'
      searchField.lock = true
      searchField.defaultSelected = 1
      searchField.selected = 1
      searchField.action = this.isFba ? AdvancedSearchField.ADD_ACTION : AdvancedSearchField.REMOVE_ACTION
      searchField.dropdownDataRef = 'RadioStatusConstants.YES_NO_TYPES'
      searchField.dataCacheKey = 'local_cache_RadioStatusConstants$YES_NO_TYPES'
      this.customSearchItems.push(searchField.formatObj2Json())

      // 海外仓
      const overseaWarehouses = getCacheListByKey(basicCacheKeys.basic_data_OverseaWarehouse)

      // 亚马逊仓库编码
      searchField = new AdvancedSearchField()
      searchField.action = this.isFba ? AdvancedSearchField.ADD_ACTION : AdvancedSearchField.REMOVE_ACTION
      searchField.itemType = 'advanceSelect'
      searchField.fieldType = 'FIELD_DROP_DOWN_LIST'
      searchField.itemName = 'fbaJob.WAREHOUSE_CODE'
      searchField.itemLabel = this.$t('FbaJob.AmazonWarehouseCode')
      searchField.tagName = 'warehouseCode'
      searchField.tagValue = 'warehouseCode'
      searchField.defaultSelected = 0
      searchField.dataProvider = overseaWarehouses.filter(p => p.ifFba)
      this.customSearchItems.push(searchField.formatObj2Json())

      // 国内仓
      searchField = new AdvancedSearchField()
      searchField.action = this.isFba ? AdvancedSearchField.ADD_ACTION : AdvancedSearchField.REMOVE_ACTION
      searchField.itemType = 'company'
      searchField.subType = {
        'type': 'warehouse',
        'tagValue': 'cmpIdx'
      }
      searchField.fieldType = 'FIELD_WAREHOUSE'
      searchField.itemName = 'warehouseInfo.WAREHOUSE_CMP'
      searchField.itemLabel = this.$t('queryJob.DomesticWarehouse')
      searchField.defaultSelected = 0
      searchField.dataProvider = []
      this.customSearchItems.push(searchField.formatObj2Json())

      // 国外仓
      searchField = new AdvancedSearchField()
      searchField.action = this.isFba ? AdvancedSearchField.ADD_ACTION : AdvancedSearchField.REMOVE_ACTION
      searchField.itemType = 'advanceSelect'
      searchField.fieldType = 'FIELD_DROP_DOWN_LIST'
      searchField.itemName = 'job.OVERSEA_WAREHOUSE_CODE'
      searchField.itemLabel = this.$t('queryJob.ForeignWarehouse')
      searchField.tagName = 'countryChineseName'
      searchField.tagValue = 'warehouseCode'
      searchField.defaultSelected = 0
      searchField.dataProvider = overseaWarehouses.filter(p => !p.ifFba)
      this.customSearchItems.push(searchField.formatObj2Json())

      // 预期入亚马逊仓时间
      searchField = new AdvancedSearchField()
      searchField.itemType = 'date'
      searchField.itemCondition = []
      searchField.defaultConditionVal = 'RANGE'
      searchField.fieldType = 'FIELD_DATE_RANGE'
      searchField.itemName = 'fbaJob.PRE_AMAZON_WH_TIME'
      searchField.itemLabel = 'FbaJob.PreAmazonWhTime'
      searchField.subType = 'range'
      searchField.defaultSelected = 0
      searchField.selected = 0
      searchField.lock = false
      searchField.defaultValue = []
      searchField.action = this.isFba ? AdvancedSearchField.ADD_ACTION : AdvancedSearchField.REMOVE_ACTION
      this.customSearchItems.push(searchField.formatObj2Json())

      // 中文品名
      searchField = new AdvancedSearchField()
      searchField.itemType = 'input'
      searchField.subType = ''
      searchField.itemCondition = []
      searchField.defaultConditionVal = ''
      searchField.fieldType = 'FIELD_TEXT'
      searchField.itemName = 'job.CARGO_CHINESE_NAME'
      searchField.itemLabel = 'SeaExport.ChineseDescriptionOfGoods'
      searchField.itemValue = ''
      searchField.defaultSelected = 0
      searchField.selected = 0
      searchField.lock = false
      searchField.defaultValue = ''
      searchField.action = this.isFba ? AdvancedSearchField.ADD_ACTION : AdvancedSearchField.REMOVE_ACTION
      this.customSearchItems.push(searchField.formatObj2Json())

      // 英文品名
      searchField = new AdvancedSearchField()
      searchField.itemType = 'input'
      searchField.subType = ''
      searchField.itemCondition = []
      searchField.defaultConditionVal = ''
      searchField.fieldType = 'FIELD_TEXT'
      searchField.itemName = 'job.CARGO_ENGLISH_NAME'
      searchField.itemLabel = 'SeaExport.EnglishDescriptionOfGoods'
      searchField.itemValue = ''
      searchField.defaultSelected = 0
      searchField.selected = 0
      searchField.lock = false
      searchField.defaultValue = ''
      searchField.action = this.isFba ? AdvancedSearchField.ADD_ACTION : AdvancedSearchField.REMOVE_ACTION
      this.customSearchItems.push(searchField.formatObj2Json())

      // 参考箱号
      searchField = new AdvancedSearchField()
      searchField.itemType = 'input'
      searchField.subType = ''
      searchField.itemCondition = []
      searchField.defaultConditionVal = ''
      searchField.fieldType = 'FIELD_TEXT'
      searchField.itemName = 'warehouseIn.REF_CONTAINER_NO'
      searchField.itemLabel = 'Warehouse.RefContainerNo'
      searchField.itemValue = ''
      searchField.defaultSelected = 0
      searchField.selected = 0
      searchField.lock = false
      searchField.defaultValue = ''
      searchField.action = this.isFba ? AdvancedSearchField.ADD_ACTION : AdvancedSearchField.REMOVE_ACTION
      this.customSearchItems.push(searchField.formatObj2Json())

      // Shipment Id
      searchField = new AdvancedSearchField()
      searchField.itemType = 'input'
      searchField.subType = ''
      searchField.itemCondition = []
      searchField.defaultConditionVal = ''
      searchField.fieldType = 'FIELD_TEXT'
      searchField.itemName = 'fbaJob.SHIPMENT_ID'
      searchField.itemLabel = 'FbaJob.ShipmentId'
      searchField.itemValue = ''
      searchField.defaultSelected = 0
      searchField.selected = 0
      searchField.lock = false
      searchField.defaultValue = ''
      searchField.action = this.isFba ? AdvancedSearchField.ADD_ACTION : AdvancedSearchField.REMOVE_ACTION
      this.customSearchItems.push(searchField.formatObj2Json())

      // // CARGO-42713 加入小票查询权限逻辑优化-只能操作看自己的
      // searchField = new AdvancedSearchField()
      // searchField.itemType = 'user'
      // searchField.subType = {
      //   'category': 'role',
      //   'shape': 'op'
      // }
      // searchField.multiple = 0
      // searchField.itemCondition = []
      // searchField.defaultConditionVal = ''
      // searchField.fieldType = 'FIELD_USER'
      // searchField.itemName = 'job.OP_ID'
      // searchField.itemLabel = 'SeaExport.Operation'
      // searchField.itemValue = ''
      // searchField.defaultSelected = 1
      // searchField.selected = 1
      // searchField.lock = (isJyd && !isAdmin)
      // searchField.defaultValue = (isJyd && !isAdmin) ? this.$store.getters.userId : 0
      // searchField.action = this.isFba ? AdvancedSearchField.REMOVE_ACTION : AdvancedSearchField.UPDATE_ACTION
      // this.customSearchItems.push(searchField.formatObj2Json())

      // 移除原【操作】条件
      searchField = new AdvancedSearchField()
      searchField.action = AdvancedSearchField.REMOVE_ACTION
      searchField.itemType = 'user'
      searchField.fieldType = 'FIELD_USER'
      searchField.itemName = 'job.OP_ID'
      this.customSearchItems.push(searchField.formatObj2Json())

      // 新的【操作】条件
      if (!this.isFba) {
        searchField = new AdvancedSearchField()
        searchField.action = AdvancedSearchField.UPDATE_ACTION
        searchField.itemType = 'customType1'
        searchField.fieldType = 'FIELD_USER'
        searchField.itemName = 'job.OP_ID'
        searchField.itemLabel = 'SeaExport.Operation'
        searchField.itemValue = ''
        searchField.defaultSelected = 1
        searchField.selected = this.joinPersonSlave ? 1 : 0
        searchField.lock = this.joinPersonSlave
        searchField.defaultValue = this.joinPersonSlave ? this.$store.getters.userId : 0
        this.customSearchItems.push(searchField.formatObj2Json())
      }

      if (!this.isFba) {
        // CARGO-28997 整拼类型是Buyer Console FCL时，可以选择整拼，其他的默认不可编辑
        const containerLoadTypeList = [ContainerLoadType.FCL_CARGO_TYPE, ContainerLoadType.BC_CARGO_TYPE_FCL]
        const isBCF = (this.job.containerLoadType === ContainerLoadType.BC_CARGO_TYPE_FCL.code)
        searchField = new AdvancedSearchField()
        searchField.itemType = 'select'
        searchField.multiple = 1
        searchField.itemCondition = []
        searchField.defaultConditionVal = ''
        searchField.fieldType = 'FIELD_MULTI_DROP_DOWN_LIST'
        searchField.itemName = 'seaJob.CONTAINER_LOAD_TYPE'
        searchField.itemLabel = 'SeaExport.FLCLType'
        searchField.itemValue = []
        searchField.defaultSelected = 1
        searchField.selected = 1
        searchField.lock = !isBCF
        searchField.valueExpression = ''
        if (isBCF) {
          searchField.dataProvider = containerLoadTypeList
          searchField.defaultValue = [ContainerLoadType.BC_CARGO_TYPE_FCL.code]
        } else {
          searchField.dropdownDataRef = 'SeaExportConstants.CONTAINER_LOAD_TYPES'
          searchField.dataCacheKey = 'local_cache_SeaExportConstants$CONTAINER_LOAD_TYPES'
          searchField.defaultValue = [this.job.containerLoadType]
        }
        searchField.action = AdvancedSearchField.UPDATE_ACTION
        this.customSearchItems.push(searchField.formatObj2Json())
        // 操作部门使用主票操作部门，且不可编辑
        searchField = new AdvancedSearchField()
        searchField.itemType = 'department5'
        searchField.multiple = 1
        searchField.itemCondition = []
        searchField.defaultConditionVal = ''
        searchField.fieldType = 'FIELD_DEPARTMENT5'
        searchField.itemName = 'job.OP_DEPARTMENT'
        searchField.itemLabel = 'SeaExport.OperationDepartment'
        searchField.itemValue = []
        searchField.defaultSelected = 1
        searchField.selected = 1
        searchField.lock = true
        searchField.valueExpression = ''
        searchField.defaultValue = [this.job.opDepartment]
        searchField.action = AdvancedSearchField.UPDATE_ACTION
        this.customSearchItems.push(searchField.formatObj2Json())

        // 船名航次默认使用主票
        searchField = new AdvancedSearchField()
        searchField.itemType = 'input'
        searchField.subType = ''
        searchField.itemCondition = []
        searchField.defaultConditionVal = ''
        searchField.fieldType = 'FIELD_TEXT'
        searchField.itemName = 'job.VESSEL'
        searchField.itemLabel = 'SeaExport.Vessel'
        searchField.itemValue = ''
        searchField.defaultSelected = 1
        searchField.selected = 1
        searchField.defaultValue = isBCF ? this.job.vessel : ''
        searchField.lock = isBCF
        searchField.action = AdvancedSearchField.UPDATE_ACTION
        this.customSearchItems.push(searchField.formatObj2Json())
        searchField = new AdvancedSearchField()
        searchField.itemType = 'input'
        searchField.subType = ''
        searchField.itemCondition = []
        searchField.defaultConditionVal = ''
        searchField.fieldType = 'FIELD_TEXT'
        searchField.itemName = 'job.VOYAGE_FLIGHT'
        searchField.itemLabel = 'SeaExport.Voyage'
        searchField.itemValue = ''
        searchField.defaultSelected = 1
        searchField.selected = 1
        searchField.defaultValue = isBCF ? this.job.voyageFlight : ''
        searchField.lock = isBCF
        searchField.action = AdvancedSearchField.UPDATE_ACTION
        this.customSearchItems.push(searchField.formatObj2Json())
      }
    },
    toQuery(data) {
      const loading = getLoading()
      if (typeof data === 'undefined' || !data || data.length === 0) {
        data = []
      }
      if (this.job.opDepartment && this.job.opDepartment > 0) {
        data.push(new AdvancedSearchOption(null, 'job.OP_DEPARTMENT', this.job.opDepartment, AdvancedSearchConsts.OPERATOR_EQUAL.code).formatObj2Json())
      }
      if (this.isFba) {
        data.push(new AdvancedSearchOption(null, 'seaJob.CONTAINER_LOAD_TYPE', this.job.containerLoadType || 'LCL', AdvancedSearchConsts.OPERATOR_EQUAL.code).formatObj2Json())
      }
      data.push(new AdvancedSearchOption(null, 'job.FBA', this.isFba, AdvancedSearchConsts.OPERATOR_EQUAL.code).formatObj2Json())
      if (this.joinSameGroupSlave) {
        if (!AdvancedSearchOption.hasField('job.OP_ID', data)) {
          const userIds = Array.from(this.departmentUsers, p => p.userId)
          data.push(new AdvancedSearchOption(null, 'job.OP_ID', userIds, AdvancedSearchConsts.OPERATOR_IN.code).formatObj2Json())
        }
      }
      getSeaExportJobsByLclMasterJob(this.$store.getters.currentOfficeId, data).then(res => {
        this.rowData = res.data
      }).finally(() => {
        loading.close()
      })
    },
    onRowDataChanged(event) {
      // 重置（多选）选中行
      this.selectedRows = []
    },
    onMultipleSelected(event) {
      this.selectedRows = event.api ? event.api.getSelectedRows() : []
    },
    async add() {
      const selectedRows = this.selectedRows // 记录当前选中的记录，避免后续被修改
      if (selectedRows.length === 0) {
        this.$message.info(this.$t('Message.SelectTheOrderYouWantToJoin'))
        return
      }
      for (const job of selectedRows) {
        if (job.lclMasterUuid) {
          this.$message.warning(job.jobNo + ' ' + this.$t('Message.HasJoinIntoMbl'))
          return
        }
      }
      const triggerCallback = () => {
        this.$emit('callback', selectedRows)
        this.innerVisible = false
      }
      if (!(await this.hasDiffField(selectedRows))) {
        let message = this.$t('Message.TheSubBillsAndMBLAreInconsistentTheSystemWillModifyTheSubBillsContinue')
        if (this.job.containerLoadType === ContainerLoadType.BC_CARGO_TYPE_FCL.code) {
          message = this.$t('Message.TheSubBillsAndMBLAreInconsistentTheSystemWillModifyTheSubBillsContinue2')
        }
        this.$confirm(message, this.$t('Message.Prompt'), {
          confirmButtonText: this.$t('common.btn.ok'),
          cancelButtonText: this.$t('common.btn.cancel'),
          closeOnClickModal: false,
          type: 'warning'
        }).then(() => {
          this.fixNewSlave(selectedRows)
          triggerCallback()
        }).catch(() => { })
      } else {
        triggerCallback()
      }
    },
    async hasDiffField(selectedRows) {
      const masterWarehouseCmp = []
      const warehouseInfos = await new Job(this.job).getWarehouseInfo()
      if (warehouseInfos && warehouseInfos.length > 0) {
        for (const w of warehouseInfos) {
          masterWarehouseCmp.push(w.warehouseCmp)
        }
      }
      for (const slave of selectedRows) {
        if (slave.vessel !== this.job.vessel) {
          return false
        }
        if (slave.voyageFlight !== this.job.voyageFlight) {
          return false
        }
        if (slave.bookingAgent !== this.job.bookingAgent) {
          return false
        }
        if (slave.destinationAgent !== this.job.destinationAgent) {
          return false
        }
        if (slave.carrierId !== this.job.carrierId) {
          return false
        }
        if (slave.paymentTermMBL !== this.job.paymentTermMBL) {
          return false
        }
        if (slave.loadingPortCode !== this.job.loadingPortCode) {
          return false
        }
        if (slave.transferPortCode !== this.job.transferPortCode) {
          return false
        }
        if (!slave.etd && this.job.eta || slave.etd !== this.job.etd) {
          return false
        }
        if (!(!slave.eta && !this.job.eta) && (!slave.eta && this.job.eta || slave.eta && !this.job.eta || slave.eta !== this.job.eta)) {
          return false
        }
        if (masterWarehouseCmp.length > 0) { // 主票存在仓库
          if (!slave.warehouseInfo || slave.warehouseInfo.length === 0) {
            return false
          } else { // 小票存在仓库，则判断是否可主票一致
            let diff = false // 默认主票和小票的仓库是不一致的
            for (const slaveWarehouseInfo of slave.warehouseInfo) {
              if (masterWarehouseCmp.includes(slaveWarehouseInfo.warehouseCmp)) {
                diff = true
                break
              }
            }
            return diff
          }
        }
      }
      return true
    },
    fixNewSlave(selectedRows) {
      for (const item of selectedRows) {
        item.vessel = this.job.vessel
        item.voyageFlight = this.job.voyageFlight
        item.bookingAgent = this.job.bookingAgent
        item.destinationAgent = this.job.destinationAgent
        item.carrierId = this.job.carrierId
        item.paymentTermMBL = this.job.paymentTermMBL
        if (item.loadingPortCode !== this.job.loadingPortCode) {
          item.hasUpdateLoadingPortCode = true
        }
        item.loadingPortCode = this.job.loadingPortCode
        item.transferPortCode = this.job.transferPortCode
        item.etd = this.job.etd
        item.eta = this.job.eta
        item.warehouseCmp = this.job.warehouseCmp
        item.warehouseInfo = item.warehouseInfo || []
        if (item.warehouseInfo.length === 0) {
          const newData = new WarehouseInfo().fillDefaultValue().getData()
          newData.jobUuid = item.uuid
          item.warehouseInfo.push(newData)
        }
        item.warehouseInfo[0].warehouseCmp = item.warehouseCmp || 0
        if ([SystemConstants.SE.code, SystemConstants.SI.code].includes(this.job.lob)) {
          if (item.dischargingPortCode !== this.job.dischargingPortCode) {
            item.hasUpdateDischargingPortCode = true
          }
          item.dischargingPortCode = this.job.dischargingPortCode
        } else if ([SystemConstants.AE.code].includes(this.job.lob)) {
          if (item.destinationPortCode !== this.job.destinationPortCode) {
            item.hasUpdateDestinationPortCode = true
          }
          item.destinationPortCode = this.job.destinationPortCode
        }
      }
    },
    beforeCloseHandler() {
      this.$confirm(this.$t('Message.CancelTheCurrentQuery'), this.$t('CargoMsg.Cargo_ConfirmR'), {
        confirmButtonText: this.$t('common.btn.yes'),
        cancelButtonText: this.$t('common.btn.no'),
        closeOnClickModal: false,
        type: 'warning'
      }).then(() => {
        this.innerVisible = false
      }).catch(() => {
      })
    },
    onItemConditionChange(item) {
      if (item.itemType === 'customType1') {
        switch (item.defaultConditionVal) {
          case AdvancedSearchConsts.OPERATOR_EQUAL.code:
          case AdvancedSearchConsts.OPERATOR_UNEQUAL.code:
            if (item.itemValue instanceof Array) {
              item.itemValue = ''
            }
            break
          case AdvancedSearchConsts.OPERATOR_IN.code:
          case AdvancedSearchConsts.OPERATOR_NOT_IN.code:
            if (!(item.itemValue instanceof Array)) {
              item.itemValue = []
            }
            break
        }
      }
    }
  }
}
</script>

<style lang="scss">
  .search {
    label {
      font-size: 12px;
      font-weight: normal;
    }
    .el-select {
      width: 100%;
    }
  }
</style>
